/**
 * 画面を揺らしてよいかの判断だけを切り出したもの。
 *
 * Phaser を読み込まないので、そのままテストできる。
 * MergeEffects 本体は Phaser に依存していて node 環境では import できない。
 */

export interface ShakePolicyInput {
  /** 設定の「画面をゆらす」。 */
  showShake: boolean;
  /**
   * 追悼・慰霊・聖域の景色（TourScene.solemn）が映っているか。
   *
   * true のときは設定より優先して揺らさない。
   * 原爆ドームや御嶽の上で画面が揺れるのは、設定の問題ではないため。
   */
  solemn: boolean;
  /** 設定の「動きを減らす」か、端末の prefers-reduced-motion。 */
  reduceMotion?: boolean;
}

/** 画面を揺らしてよければ true。 */
export function shouldShake({ showShake, solemn, reduceMotion }: ShakePolicyInput): boolean {
  if (solemn) return false;
  if (reduceMotion) return false;
  return showShake;
}

/** 端末側で「動きを減らす」が選ばれているか（読めない環境では false）。 */
export function prefersReducedMotion(): boolean {
  try {
    return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

/** 設定と端末のどちらかで動きを減らすなら true。 */
export function isMotionReduced(settings: { reduceMotion?: boolean }): boolean {
  return Boolean(settings.reduceMotion) || prefersReducedMotion();
}
